<template>
    <div>
        <Row type="flex" justify="space-between" align="middle" class="code-row-bg">
            <!-- tanggal bongkar -->
            <Col span="2">
            {{ invoiceDue.invoicedate | showDateFormatted }}
            </Col>
            <!-- desc -->
            <Col span="5">
            {{ invoiceDue.description }}
            </Col>

            <!-- total -->
            <Col span="1" align="right">
            {{ invoiceDue.invoicefee | currency }}
            </Col>

            <!-- tool tip kalo ? -->
            <Col span="1">
            <Tooltip v-show="invoiceDue.receivableDebitAmount != invoiceDue.invoicefee" placement="top">
                <Icon type="ios-help-outline"></Icon>
                <div slot="content">
                    <template>
                        Invoice Awal : {{ invoiceDue.receivableDebitAmount | currency }}
                    </template>
                </div>
            </Tooltip>
            </Col>

            <!-- sisa jika invoicefee sama dengan sisanya -->
            <template v-if="invoiceDue.invoicefee == invoiceDue.receivableRemaining">
                <Col span="2" align="right">
                {{ invoiceDue.receivableRemaining | currency }}
                </Col>
            </template>

            <!-- sisa jika invoicefee tidak sama dengan sisanya -->
            <template v-else>
                <Col span="2" align="right" style="color: red;">
                {{ invoiceDue.receivableRemaining | currency }}
                </Col>
            </template>

            <!-- tooltip ket selisih invoicefee dengan receivbale remaining -->
            <Col span="1">
            <Tooltip v-show="invoiceDue.receivableRemaining != invoiceDue.invoicefee" placement="top">

                <Icon type="ios-help-outline"></Icon>
                <div slot="content">
                    <!-- Total Bayar : {{ invoiceDue.receivableRemaining  | currency}} -->
                    Total Bayar : {{ invoiceDue.paymentSum | currency }}
                </div>
            </Tooltip>
            </Col>
            <Col span="3">

            <!-- allocate Amount -->
            <money v-model="allocateAmount" v-bind="money" class="ivu-input ivu-input-small">
            </money>

            <div v-show="depositRemaining > 0" style="margin-top:10px;">
                Deposit <money v-model="useDepositAmount" v-bind="money" class="ivu-input ivu-input-small"
                    style="width : 120px">
                </money>
            </div>

            <div v-show="totalDepositMutasi > 0" style="margin-top:10px;">
                Deposit Mutasi <money v-model="useDepositMutasi" v-bind="money" class="ivu-input ivu-input-small"
                    style="width : 120px">
                </money>
            </div>

            <div v-show="depositMutasiRemaining
   > 0" style="margin-top:10px;">
                Deposit Mutasi <money v-model="useDepositMutasi" v-bind="money" class="ivu-input ivu-input-small"
                    style="width : 120px">
                </money>
            </div>
            </Col>
            <Col span="3">
                <div>
                    <money v-model="discountAmount" @input="maximalDiscount" v-bind="money" class="ivu-input ivu-input-small">
                    </money>
                </div>
                <div style="margin-top: 10px;" v-show="discountAmount > 0">
                  <div>
                      <!-- <span style="font-size: 12px">Keterangan Potongan 3</span> -->
                      <Input v-model="discountDescription" placeholder="Keterangan Potongan" size="small" ></Input>
                  </div>
                </div>
            </Col>
            <Col span="1">
            <Button-group size="small">
                <Button type="success" @click="toggleAllocateAll()">All</Button>
            </Button-group>
            </Col>
        </Row>
        <Row>
            <Col span="24">
            <br />
            <hr />
            </Col>
        </Row>
    </div>
</template>

<script>
import { Money } from 'v-money'
const numeral = require('numeral');
import moment from 'moment'


export default {
    props: {
        invoiceDue: Object,
        depositRemaining: Number,
        depositMutasiRemaining: Number,
        totalDepositMutasi: Number,
    },
    data: () => ({
        allocateAmount: 0,
        allocateMutasiAmount: 0,
        useDepositAmount: 0,
        useDepositMutasi: 0,
        discountAmount: 0,
        discountDescription: '',
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 0,
            masked: false
        }
    }),
    components: { Money },
    methods: {
        toggleAllocateAll: function () {
            let receivableRemaining =
                this.invoiceDue.receivableRemaining - (this.allocateAmount + this.useDepositAmount + this.useDepositMutasi)

            this.allocateAmount += receivableRemaining;
        },
        emitAllAmount: function () {
            this.$emit('setAllocateAmount', this.invoiceDue)
        },
        maximalDiscount: function () {
          if (this.discountAmount > this.invoiceDue.receivableRemaining) {
            this.discountAmount = this.invoiceDue.receivableRemaining;
          }
          this.$forceUpdate();
        },
    },

    watch: {
        allocateAmount: function (newAllocateAmount) {
            this.invoiceDue.allocateAmount = parseFloat(this.allocateAmount) || 0;
            let amount = this.allocateAmount + this.discountAmount;

            if (amount > this.invoiceDue.receivableRemaining) {
              this.discountAmount = 0
            }

            this.emitAllAmount();
        },
        discountAmount: function (newDiscountAmount) {
          this.invoiceDue.discountAmount = parseFloat(this.discountAmount) || 0;
          let amount = this.allocateAmount + this.discountAmount;

          if (amount > this.invoiceDue.receivableRemaining) {
            this.allocateAmount = (this.allocateAmount - this.discountAmount) + (this.invoiceDue.receivableRemaining - this.allocateAmount)
          }
          this.emitAllAmount();
        },
        discountDescription: function () {
          this.invoiceDue.discountDescription = this.discountDescription;
          this.emitAllAmount();
        },
        useDepositAmount: function (newUseDepositAmount) {
            this.invoiceDue.useDepositAmount = _.parseInt(this.useDepositAmount);
            this.emitAllAmount();
        },
        useDepositMutasi: function (newUseDepositMutasi) {
            this.invoiceDue.useDepositMutasi = _.parseInt(this.useDepositMutasi);
            this.emitAllAmount();
        }
    },

    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        }
    },

    mounted() {
        console.info('mounted', this.depositMutasiRemaining)
    }
}

</script>
<style></style>



// WEBPACK FOOTER //
// cInvoicePayment.vue?ea550114